import {
  LightLineSheet,
  LightLineSheetSet,
} from "@/features/line-sheet-sets/line-sheet-set.types";
import { Boutique } from "@/features/types";

// 오더 목록은 오더를 먼저 받고, 연결된 라인시트 세트는 "그 회사가 볼 수 있는 라인시트 세트 목록"에서
// 따로 받아 붙인다. 바이어는 발행·공유·연결된 에이전시 조건에 맞는 세트만 받으므로, 오더를 넣은 뒤
// 세트가 발행 해제되거나 공유가 빠지면 그 오더의 세트를 못 받는다. 그때 목록 전체가 깨지지 않도록
// 화면이 읽는 칸만 '-' 로 채운 자리표시 세트를 쓴다(2026-10-19 PATHRADE-6J).

export const MISSING_TEXT = "-";

// 금액 표기가 통화 코드로 서식을 만들므로 유효한 코드여야 한다 — 세트 통화를 모르면 유로로 둔다.
const FALLBACK_CURRENCY = "EUR";

export function placeholderLineSheet(id: number): LightLineSheet {
  return {
    id,
    type: "LINE_SHEET",
    name: MISSING_TEXT,
    file: null,
    unoFormFile: null,
    status: "PARSING_COMPLETED",
    reviewStatus: null,
    compressionStatus: null,
    lineSheetTabs: [],
    updatedAt: null,
    seasons: [],
    brands: [],
    isAllProductsHaveBrand: null,
  } as unknown as LightLineSheet;
}

export function placeholderLineSheetSet(
  id: number,
  issuedByBoutique?: Boutique | null
): LightLineSheetSet {
  return {
    id,
    name: MISSING_TEXT,
    season: MISSING_TEXT,
    issuedAt: null,
    issuedByBoutique: issuedByBoutique ?? { id: -1, name: MISSING_TEXT },
    brands: [],
    issuedToBuyers: [],
    status: "PARSING_COMPLETED",
    reviewStatus: null,
    compressionStatus: null,
    type: MISSING_TEXT,
    validUntil: null,
    currency: FALLBACK_CURRENCY,
    orderRules: [],
    orderRuleFiles: [],
    attachments: [],
    lineSheets: [],
    createdByCompany: { id: -1, name: MISSING_TEXT },
    createdAt: null,
    updatedAt: null,
    publishedAt: null,
    externalFileLinks: [],
    compressedImportedFile: null,
    compressedUnoFormFile: null,
    unoFormFile: null,
    isRead: true,
    isDeleted: false,
    searchedSkus: [],
  } as unknown as LightLineSheetSet;
}
